import * as React from 'react'
import styled from 'styled-components'
import { SiteAlias, WebshopPackage } from '../../../schema/webshop-package'

import ProductCard from '../product-card/product-card'
import breakpoints from '../../../stories/theme/breakpoints'
import Select from '../../../stories/atoms/Select/Select'
import Link from '../../../stories/atoms/Link/Link'
import ArrowLeftSvg from '../../../stories/atoms/Icons/Button/ArrowLeft'

const Container = styled.div`
  display: flex;
  flex-direction: column;
`
const FilterSection = styled.section`
  margin-bottom: 30px;
  width: 300px;

  @media (max-width: ${breakpoints.tablet}) {
    width: 100%;
  }
`

const BackLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 2px;
  margin-bottom: 16px;
  height: 24px;
`

type Props = {
  className?: string
  products: WebshopPackage[]
  targetProductCodes: string[]
}

const ProductDetail: React.FunctionComponent<Props> = ({ className, products, targetProductCodes }: Props) => {
  const [selectedBrandFilter, setSelectedBrandFilter] = React.useState<SiteAlias | ''>('')

  const onBrandFilterChange = ({ value }) => {
    const brand = value === 'Alle merken' ? '' : value
    setSelectedBrandFilter(brand)
  }

  const productForSelectedSite = (product: WebshopPackage, site: SiteAlias) =>
    product.jobPosting && product.jobPosting.publishOn.includes(site)

  const productForCvDatabase = (product: WebshopPackage) => !product.jobPosting && !product.upgrades.length

  const upgradeForSelectedSite = (product: WebshopPackage, site: SiteAlias) =>
    product.upgrades.filter(u => u.sites.includes(site) || u.requiredSites.includes(site)).length

  const targetProducts = [...new Set(targetProductCodes)]
    .filter(pCode => products.find(p => p.productCode === pCode))
    .map(pCode => products.find(p => p.productCode === pCode))

  if (targetProducts.length) {
    return (
      <Container className={className} data-testid="webshopProductsList">
        <BackLink href="/webshop"><ArrowLeftSvg height={10} /> Alle producten</BackLink>
        {targetProducts.map(product => (
          <ProductCard key={product.productCode} product={product} />
        ))}
      </Container>
    )
  }

  return (
    <Container className={className} data-testid="webshopProductsList">
      {!!products.length && (
        <>
          <FilterSection>
            <Select
              isTouched
              isValid
              onChange={onBrandFilterChange}
              validationMessage=""
              value={selectedBrandFilter}
              options={[
                {
                  value: 'Alle merken',
                  label: 'Alle merken',
                },
                {
                  value: 'intermediair',
                  label: 'Intermediair',
                },
                {
                  value: 'nationalevacaturebank',
                  label: 'Nationale Vacaturebank',
                },
              ]}
              placeholder="Selecteer merken"
            />
          </FilterSection>

          {products
            .filter(
              product =>
                !selectedBrandFilter ||
                productForSelectedSite(product, selectedBrandFilter) ||
                productForCvDatabase(product) ||
                upgradeForSelectedSite(product, selectedBrandFilter),
            )
            .map(product => (
              <ProductCard key={product.productCode} product={product} />
            ))}
        </>
      )}
    </Container>
  )
}

export default ProductDetail
